import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentFiltersView from './PaymentFilters.view';

import { getTypes } from '../Payments.selectors';

export class PaymentFiltersContainer extends Component {
  render() {
    return (<PaymentFiltersView
      {...this.props}
    />);
  }
}

function mapStateToProps(state) {
  return {
    cardTypes: getTypes(state),
  };
}

export default connect(mapStateToProps)(PaymentFiltersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentFilters/PaymentFilters.container.js